export const SAT_COURSES = {
  SAT_DEMO: 'SAT-DEMO',
  SAT_MATH: 'SAT-MATH',
  SAT_ENGLISH: 'SAT-ENGLISH',
  SAT_TESTS: 'SAT-TESTS',
} as const;

export const PROGRAM_STREAM_TYPE = {
  MATH: 'MATH',
  CODING: 'CODING',
  ELA: 'ELA',
  SCIENCE: 'SCIENCE',
  ELP: 'ELP',
  ...SAT_COURSES,
} as const;

export const CUE_PROGRAM_TYPE = {
  ELECTIVES: 'ELECTIVES',
  CORE: 'CORE',
} as const;
